import { render, staticRenderFns } from "./Gutou.vue?vue&type=template&id=5fc726a6&scoped=true&"
import script from "./Gutou.vue?vue&type=script&lang=js&"
export * from "./Gutou.vue?vue&type=script&lang=js&"
import style0 from "./Gutou.vue?vue&type=style&index=0&id=5fc726a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc726a6",
  null
  
)

export default component.exports